// TODO the code used for eeListClick events need refactoring.

var cbtUtil = require("./cbtUtil");
var setCookie = require("coremh/components/cookieSetup").setCookie;
var getCookie = require("coremh/components/cookieSetup").getCookie;
var deleteCookie = require("coremh/components/cookieSetup").deleteCookie;

function cbtPdpClickData() {
    if (getCookie("eeListClick_pdp_doPush") == "1") {
        deleteCookie("eeListClick_pdp_doPush");
        var clickData = $("#product-details").data("cbt");
        var dataLayer = cbtUtil.parseJSON(clickData);
        if (dataLayer) {
            cbtUtil.dataPush(dataLayer);
        }
    }
}

function cbtOutOfStockNotification() {
    $("body").on("cbtOutOfStockNotification", function(e, cbtData) {
        cbtUtil.dataPush(cbtData);
    });
}

function cbtPDPInteractions() {
    let pdpData = cbtUtil.parseJSON($(".cbt-pdp").data("pdp-cbt"));
    let productName = pdpData?.products?.[0]?.name || $(".js-product-name").first().text().trim();

    [
        // [event, target selector, interactionType]
        ["click", ".product-tabs .product-tabs-link", ""],
        ["click", ".product-food-pairing .food-pairing-link", "Food pairing - "],
        ["click", ".product-detail .play-auto-carousel", "Play auto-carousel"],
        ["click", ".review-carousel .slick-arrow", "See more expert reviews"],
        ["swipe", ".product-review .slick-slider", "See more expert reviews"],
        ["click", ".description-and-detail .read-more", "Read more"],
        ["click", ".product-detail .personalization-link-wrapper", "Click personalize"],
        ["click", ".product-detail .pdp-carousel-wrapper .slick-arrow", "Swipe picture"],
        ["swipe", ".product-detail .pdp-carousel-wrapper .slick-slider", "Swipe picture"],
    ].forEach(function (e) {
        $("body").on(e[0], e[1], function () {
            cbtUtil.dataPush({
                event: "productFeature",
                interactionType: e[2] + ($(this).data("interaction") || ""),
                productName: productName,
            });
        });
    });
}
/**
 * Use cookie to provide data for eeListClick listName and listType properties,
 * for adding product to cart and for after visiting PDP.
 * Cookie is updated on click.
 * Valid for crossSell products
 */
function cbtPdpClickCrossSellData() {
    const buttonSelector = ".producttile-add-to-cart";
    $(".product-growth-list-section").each(function () {
        const $element = $(this);
        let listName = null;
        let listType = null;
        if ($element.hasClass("js-product-recommendations")) {
            listName = "Something unexpected";
            listType = "PDP - Something unexpected";
        } else if ($element.hasClass("suggested-product")) {
            const dataLayerPDP = cbtUtil.parseJSON($(".cbt-pdp").data("pdp-cbt"));
            listName = dataLayerPDP?.products?.[0]?.name;
            listType = "PDP - Related accessories";
        }
        $element.find(buttonSelector).each(function () {
            let dataLayer = $(this).data("cbt");
            if (!dataLayer) {
                return;
            }
            if (listName) {
                dataLayer.listName = listName;
            }
            if (listType) {
                dataLayer.listType = listType;
            }
            $(this).attr("data-cbt", JSON.stringify(dataLayer));
        });
    });

    // TODO: check if this cant be merged with cbtProductTileClick from cbtGlobal.js, as both events are called for PDP recommendations
    $(".product-growth-list-section").on("click", function () {
        const dataLayer = $(this).find(buttonSelector).data("cbt");
        if (!dataLayer) {
            return;
        }
        let listName = dataLayer.listName || "";
        let listType = dataLayer.listType || "";
        const previousSiteLocation = getCookie("previousSiteLocation");
        if (previousSiteLocation) {
            const args = decodeURIComponent(previousSiteLocation).split("|");
            const pipeline = args[0] || "";
            const querystring = args[1] || "";
            setCookie("previousSiteLocation", [
                pipeline,
                querystring,
                "",
                listName,
                listType,
            ].join("|"));
        }
        setCookie("eeListClick_pdp_doPush", "1");
    });
}

/**
 * ViewData for the product recommendations on the PDP page
 * @returns {void}
 */
function cbtPdpRecommendationsViewData() {
    const $productRecomendations = $(".product-growth-list-section");

    if (!$productRecomendations.length) {
        return;
    }

    const $activeSlides = $productRecomendations.find(".slick-active");

    if (!$activeSlides.length) {
        return;
    }

    const cbtAllPages = cbtUtil.parseJSON($(".cbt-all-pages").data("cbt-all-pages"));
    const dataLayer = {
        "event": "eeListView",
        "currencyCode": cbtAllPages && cbtAllPages.currencyCode ? cbtAllPages.currencyCode : "",
        "listName": "Something unexpected",
        "listType": "PDP - Something unexpected",
        "products": []
    };

    $activeSlides.each(function(i, el) {
        let $element = $(el);
        if (!$element.hasClass("slick-cloned") && !$element.hasClass("cbt-listed")) {
            $element.addClass("cbt-listed");
            var productCbtData = cbtUtil.parseJSON($(el).find(".producttile-add-to-cart").data("cbt"));
            //The GTM attribute products of productCbtData only contains one product even though it is plural
            //The GTM attribute products of dataLayer will contain multiple products
            if (productCbtData && productCbtData.products) {
                productCbtData.products[0].position = $element.data("slick-index") + 1;
                dataLayer.products.push(productCbtData.products[0]);
            }
        }
    });

    if (dataLayer.products.length) {
        cbtUtil.dataPush(dataLayer);
    }
}

window.addEventListener("load", function () {
    cbtPdpClickData();
    cbtOutOfStockNotification();
    cbtPDPInteractions();
    cbtPdpClickCrossSellData();
    cbtPdpRecommendationsViewData();
});
